export default {"src":"/_next/static/image/public/images/flags/flag_84.4d42ebf6cc69108d0d49de499cd54878.svg","height":16,"width":24};